import { render, staticRenderFns } from "./Weekly.vue?vue&type=template&id=ec1cdb8a&scoped=true"
import script from "./Weekly.vue?vue&type=script&lang=js"
export * from "./Weekly.vue?vue&type=script&lang=js"
import style0 from "./Weekly.vue?vue&type=style&index=0&id=ec1cdb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1cdb8a",
  null
  
)

export default component.exports